<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <div class="row">
        <label for="information" class="labelInformation">
            Message
        </label>
    </div>
    <div class="row">
        <div class="col">
            <textarea class="form-control" [(ngModel)]="smsMessage" (input)="updateSendSmsButton()"></textarea>
        </div>

    </div>
    <div class="row">
        <div class="d-flex justify-content-end" style="padding-top: 10px; padding-bottom: 10px;">
            <button [disabled]="isDisabledSendSms" (click)="sendSMS()" type="button" class="btn btn-primary"
                >
                <span *ngIf="!isProcessing">Send SMS</span>
                <span *ngIf="isProcessing">
                    Processing...
                    <span class="spinner-border spinner-border-sm" role="status" ></span>
            
            </span>
            </button>
        </div>



    </div>

</div>

<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">


    <app-table-control [data]="sims" [columns]="getColumns()" [pageSize]="5" [showCheckboxes]="true"
        (selectedItemsChange)="onSelectionChange($event)" (actionClick)="onAction($event)"
        [actionButtons]="actionButtons" [showActions]="true" [clearSelection]="shouldClearSelection">
    </app-table-control>

</div>

<app-device-api-logs [filter]="'SendSMS'" [device]="selectedDevice" [showModal]="showDeviceApiLogsModal"
    (onDismiss)="onDismiss($event)"></app-device-api-logs>